var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 108,
    viewBox: "0 0 82 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tauqqdo1za",
    x1: "88.788%",
    x2: "37.803%",
    y1: "-9.481%",
    y2: "69.948%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6654D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tauqqdo1za)",
    d: "M79.862 62.994L33.875 107.66 0 44.959 43.875 2z",
    opacity: 0.3,
    transform: "translate(-510 -1222) translate(510 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEFED",
    d: "M80.489 4.071L80.489 59.142 79.271 62.351 46.549 63.159 43.218 60.741 43.218 4.071 43.854 1.239 78.522 1.239z",
    transform: "translate(-510 -1222) translate(510 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6654D",
    fillRule: "nonzero",
    d: "M77.25 0l.204.005c2.15.106 3.867 1.894 3.867 4.078v55.834l-.005.204C81.21 62.278 79.426 64 77.251 64H46.07l-.204-.005C43.717 63.889 42 62.101 42 59.917V4.083l.005-.204C42.111 1.722 43.895 0 46.07 0h31.18zm2.612 52.833H43.46v7.084l.005.165c.085 1.367 1.22 2.452 2.606 2.452h31.18l.166-.005c1.364-.085 2.446-1.224 2.446-2.612v-7.084zM64.616 56.95v1.466h-5.913V56.95h5.913zm15.246-44.317H43.46v38.734h36.403V12.633zM62.27 25.036l1.336.268-2.725 13.658-1.336-.268 2.725-13.658zm6.496 2.484L73.232 32l-4.467 4.479-.965-.967L71.304 32 67.8 28.487l.965-.967zm-14.38.001l.965.967-3.501 3.513 3.5 3.51-.964.967L49.919 32l4.466-4.479zM77.25 1.466H46.07l-.166.005c-1.364.085-2.446 1.224-2.446 2.612v7.084h36.403V4.083l-.005-.165c-.085-1.367-1.22-2.452-2.606-2.452zm-13.085 4.63V7.56h-5.912V6.095h5.912z",
    transform: "translate(-510 -1222) translate(510 1222)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceicon1);
export default __webpack_public_path__ + "static/media/serviceicon1.53e6201b48e997c36457b903206d6ade.svg";
export { ForwardRef as ReactComponent };